import api from './api';

const authHeaders = () => ({
  Authorization:
    localStorage.getItem(
      'authToken'
    )
});

const jsonHeaders = () => ({
  'Content-Type':
    'application/json',

  Authorization:
    localStorage.getItem(
      'authToken'
    )
});

const parseResponse =
  async (response) => {
    const text =
      await response.text();

    let data = {};

    try {
      data =
        text
          ? JSON.parse(text)
          : {};
    } catch (_) {
      throw new Error(
        `Server error (${response.status})`
      );
    }

    if (
      !response.ok ||
      data.error
    ) {
      throw new Error(
        data.message ||
        'Request failed'
      );
    }

    return data;
  };


const certificateApi = {

  getTemplates:
    async () => {
      const response =
        await fetch(
          `${api.BASE_URL}/certificate/templates`,
          {
            headers:
              authHeaders()
          }
        );

      return parseResponse(
        response
      );
    },


  uploadTemplate:
    async ({
      file,
      templateName,
      templateCode
    }) => {
      const form =
        new FormData();

      form.append(
        'template_name',
        templateName
      );

      form.append(
        'template_code',
        templateCode
      );

      form.append(
        'file',
        file
      );

      const response =
        await fetch(
          `${api.BASE_URL}/certificate/template`,
          {
            method:
              'POST',

            headers:
              authHeaders(),

            body:
              form
          }
        );

      return parseResponse(
        response
      );
    },


  importBatch:
    async ({
      file,
      templateId,
      batchName,
      commonFields
    }) => {
      const form =
        new FormData();

      form.append(
        'template_id',
        templateId
      );

      form.append(
        'batch_name',
        batchName
      );

      Object.entries(
        commonFields
      ).forEach(
        ([key, value]) => {
          if (value) {
            form.append(
              key,
              value
            );
          }
        }
      );

      form.append(
        'file',
        file
      );

      const response =
        await fetch(
          `${api.BASE_URL}/certificate/batch/import`,
          {
            method:
              'POST',

            headers:
              authHeaders(),

            body:
              form
          }
        );

      return parseResponse(
        response
      );
    },


  getBatches:
    async () => {
      const response =
        await fetch(
          `${api.BASE_URL}/certificate/batches`,
          {
            headers:
              authHeaders()
          }
        );

      return parseResponse(
        response
      );
    },


  getBatch:
    async (id) => {
      const response =
        await fetch(
          `${api.BASE_URL}/certificate/batch/${id}`,
          {
            headers:
              authHeaders()
          }
        );

      return parseResponse(
        response
      );
    },


  generate:
    async ({
      batchId,
      certificateIds,
      pdfMode
    }) => {
      const response =
        await fetch(
          `${api.BASE_URL}/certificate/generate`,
          {
            method:
              'POST',

            headers:
              jsonHeaders(),

            body:
              JSON.stringify({
                batch_id:
                  batchId,

                certificate_ids:
                  certificateIds,

                pdf_mode:
                  pdfMode
              })
          }
        );

      return parseResponse(
        response
      );
    },


  sendEmail:
    async (payload) => {
      const response =
        await fetch(
          `${api.BASE_URL}/certificate/send-email`,
          {
            method:
              'POST',

            headers:
              jsonHeaders(),

            body:
              JSON.stringify(
                payload
              )
          }
        );

      return parseResponse(
        response
      );
    },


  downloadSample:
    async () => {
      const response =
        await fetch(
          `${api.BASE_URL}/certificate/sample-excel`,
          {
            headers:
              authHeaders()
          }
        );

      if (!response.ok) {
        throw new Error(
          'Failed to download sample'
        );
      }

      const blob =
        await response.blob();

      const url =
        URL.createObjectURL(
          blob
        );

      const link =
        document.createElement(
          'a'
        );

      link.href = url;

      link.download =
        'Certificate_Upload_Template.xlsx';

      link.click();

      URL.revokeObjectURL(
        url
      );
    },


  downloadCertificate:
    async (id) => {
      const response =
        await fetch(
          `${api.BASE_URL}/certificate/download/certificate/${id}`,
          {
            headers:
              authHeaders()
          }
        );

      if (!response.ok) {
        throw new Error(
          'Download failed'
        );
      }

      const blob =
        await response.blob();

      const url =
        URL.createObjectURL(
          blob
        );

      window.open(
        url,
        '_blank'
      );
    },


  downloadOutput:
    async (id) => {
      const response =
        await fetch(
          `${api.BASE_URL}/certificate/download/output/${id}`,
          {
            headers:
              authHeaders()
          }
        );

      if (!response.ok) {
        throw new Error(
          'Download failed'
        );
      }

      const blob =
        await response.blob();

      const url =
        URL.createObjectURL(
          blob
        );

      window.open(
        url,
        '_blank'
      );
    }
};

export default certificateApi;